import React from 'react';
import {PortalWithState} from 'react-portal';
import PropTypes from 'prop-types';
import Button from '../Button';
import Modal from '../contact/Modal';
import styles from './contact-link.module.scss';

const buttonClass = (className, size) => {
  if (size === 'large') {
    return `is-fullwidth ${className}`.trim();
  }
  return className;
};

const className = size => {
  if (size === 'large') {
    return styles.ContactLink__wrapper;
  }
  return '';
};

const ContactLink = ({inverted, buttonClassName, buttonSize}) => (
  <PortalWithState closeOnEsc={true}>
    {({openPortal, portal, closePortal}) => (
      <div className={className(buttonSize)}>
        <Button
          className={buttonClass(buttonClassName, buttonSize)}
          inverted={inverted}
          onClick={openPortal}
        >
          Contact Us
        </Button>
        {portal(<Modal close={closePortal} />)}
      </div>
    )}
  </PortalWithState>
);

ContactLink.propTypes = {
  buttonClassName: PropTypes.string,
  buttonSize: PropTypes.oneOf(['normal', 'large']),
  inverted: PropTypes.bool,
};

ContactLink.defaultProps = {
  buttonClassName: '',
  buttonSize: 'normal',
  inverted: true,
};

export default ContactLink;



// WEBPACK FOOTER //
// ./src/components/header/ContactLink.js